import React from "react";
import VerticalTabs from "../../../shared/ReusableComponents/VerticalTabs";
import { StudentFluidOrder } from "./StudentFluidOrder";

export const StudentFluidOrderNav = ({ caseId }: { caseId: any }) => {
  const GetTabs = () => [
    {
      Text: "Adult Fluid Order",
      Component: <StudentFluidOrder caseId={caseId} />,
    },
  ];
  return <VerticalTabs GetTabs={GetTabs} />;
};
